import { RequestActions } from '../../core/api/state';
import type { EditStatus } from './models';

const actions = {
  LOAD_APPS: new RequestActions('[App] Load apps'),
  TOGGLE_SIDEBAR: '[App] Toggle Sidebar',
  TOGGLE_ACTION_DRAWER: '[App] Toggle Action Drawer',
  SET_EDIT_STATUS: '[App] Set edit status',
  UPDATE_LOCATION: '[App] Update location on app',
  TOGGLE_CONGRATULATIONS_PLANET: '[App] Toggle Congratulations Planet',
  toggleSidebar: () => ({
    type: actions.TOGGLE_SIDEBAR,
  }),
  toggleActionDrawer: () => ({
    type: actions.TOGGLE_ACTION_DRAWER,
  }),
  setEditStatus: (status: EditStatus) => ({
    type: actions.SET_EDIT_STATUS,
    payload: status,
  }),
  toggleCongratulationsPlanet: (showCongratulationsPlanet: boolean) => ({
    type: actions.TOGGLE_CONGRATULATIONS_PLANET,
    payload: showCongratulationsPlanet,
  }),
};

export default actions;
